export const MAP_POPUP_ENABLED_LOCAL_STORAGE_KEY = 'mapPopupEnabled';

export const loadMapPopupEnabledValue = () => localStorage.getItem(MAP_POPUP_ENABLED_LOCAL_STORAGE_KEY) === 'true';

export const saveMapPopupEnabledValue = (value: boolean) => localStorage.setItem(MAP_POPUP_ENABLED_LOCAL_STORAGE_KEY, JSON.stringify(value));
